import React from "react";
import SvgEmail from "components/svg/Email";

const SolutionFactoryCell = ({ config, data }) => {

    const renderSolutionFactory = (value) => {
        if (!value) {
            return null;
        }

        return <>
            {value ? <>
                {value}<br />
            </> : null}
        </>
    }


    const renderEmail = (value) => {
        if (!value) {
            return null;
        }

        return <>
            {value ? <>
                <SvgEmail />{" " + value}
            </> : null}
        </>
    }

    return data ? <>
        {renderSolutionFactory(data.label)}
        {renderEmail(data.value.email)}
    </> : null;
}

export default SolutionFactoryCell;